import { z } from 'zod';

export const apiSchema = z
  .object({
    VITE_BACKEND_ENDPOINT: z.string().optional(),
  })
  .transform((env) => ({
    api: {
      backendEndpoint: env.VITE_BACKEND_ENDPOINT,
    },
  }));
